import { save, load } from "../../../../utils/storage"
import { callFirebaseFunction } from "../../../../services/callFirebaseFunction"
import { Client as ConversationsClient } from "@twilio/conversations"

export const getTwilioAccessToken = async (forceRefresh: boolean = false) => {
  const currentTime = Date.now()
  // Token expires after 1 hour
  const hourInMilliseconds = 60 * 60 * 1000
  const buffer = 0.9

  const storedToken = load<{ token: string; expireTime: number }>("twilioAccessToken")
  const storedTokenExpireTime = storedToken
    ? storedToken.expireTime - hourInMilliseconds + hourInMilliseconds * buffer
    : 0

  if (storedTokenExpireTime && storedTokenExpireTime > currentTime && !forceRefresh) {
    return storedToken.token
  } else {
    const response = await callFirebaseFunction({
      name: "twilioAccessToken",
      payload: null,
    })
    if (response.error) throw new Error(response.message)
    const token = response.data.token

    const expireTime = currentTime + hourInMilliseconds
    save("twilioAccessToken", { token, expireTime })
    return token
  }
}

export const getNavigatorStates = async () => {
  const navigatorStates = {}

  try {
    const token = await getTwilioAccessToken()
    const conversationClient = new ConversationsClient(token)
    const conversations = await conversationClient.getSubscribedConversations()

    for (const item of conversations.items) {
      navigatorStates[item.uniqueName] = {
        readMessageIndex: item.lastReadMessageIndex ?? 0,
        lastMessageIndex: item.lastMessage?.index ?? 0,
        lastMessageDate: item.lastMessage?.dateCreated ? item.lastMessage.dateCreated.valueOf() : 0,
      }
    }

    await conversationClient.shutdown()
  } catch (error) {
    console.error("failed to get navigator states from twilio", { error })
  }

  return navigatorStates
}
